import { IStorePackage } from 'models/store/i-store-package.interface';

/**
 * Calculate pagination data for store packages
 */
export const calculatePagination = (allPackages: IStorePackage[], currentPage: number, itemsPerPage: number) => {
  const totalItems = allPackages.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const data = allPackages.slice(startIndex, endIndex);

  const hasNextPage = currentPage < totalPages;
  const hasPreviousPage = currentPage > 1;
  const shouldShowPagination = totalPages > 1;

  return {
    data,
    totalItems,
    totalPages,
    hasNextPage,
    hasPreviousPage,
    shouldShowPagination,
  };
};

/**
 * Get items per page based on window width
 */
export const getItemsPerPage = (width: number, mobileBreakpoint: number, mobileCount: number, desktopCount: number) => {
  return width < mobileBreakpoint ? mobileCount : desktopCount;
};
